export function fmtPct(n: number | null | undefined): string {
  if (n == null) return '—';
  return `${n.toFixed(1)}%`;
}

export { fmtCurrency } from '../ContactOverview/contactOverviewFormatUtils';
